<input type="text" [readOnly]="readMode" class="form-control" [(ngModel)]="searchCity"
    (input)="SearchCity()" (blur)="NotifyParent()"
    placeholder="Search..." [attr.list]="'city'+this.idx">

<datalist [id]="'city'+this.idx">
    @for (x of cities; track $index) {
        <option>
            {{ x.id }}. {{ x.descr }}
        </option>
    }
</datalist>